module.exports = __webpack_public_path__ + "img/_6875.7ed3bd26.jpg";